import { render } from "./WaitingForLink.vue?vue&type=template&id=0e35d748&lang=true"
import script from "./WaitingForLink.vue?vue&type=script&lang=js"
export * from "./WaitingForLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__